import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmPaperclip = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon-llm-paperclip",
    "data-icon": "icon-llm-paperclip",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
    })
  }));
});
IconLlmPaperclip.displayName = 'IconLlmPaperclip';

export { IconLlmPaperclip };
//# sourceMappingURL=llm-paperclip.js.map
